import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { HouseholdMetadataComponentAbstract } from '../../metadata-components/household-metadata/household-metadata.component.abstract';

@Component({
  selector: 'app-household-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent],
  templateUrl: './household-metadata-v2.component.html',
})
export class HouseholdMetadataV2Component extends HouseholdMetadataComponentAbstract {}
